import { Controller } from 'stimulus'

export default class extends Controller {
    click () {
        $('html, body').animate({ scrollTop: 0 })
    }
}
